/*
  ntx-seri.js — toptan 5'li seri yardimcilari (2026-10-26).

  Numtex toptan urunleri "Seri" secenegiyle satilir: 5 Adet S ... 5 Adet 2XL
  ve Karisik Seri. Sepette 1 adet = 1 seri (5 parca), fiyat seri fiyatidir.

  1) <ntx-seri-dagilim>: Karisik Seri seciliyken beden dagilimini (toplam 5)
     sepete eklemeden ONCE sectirir; dagilim "Beden dağılımı" satir ozelligi
     olarak urun formuna baglidir (form="..." ile). Toplam 5 degilse sepete
     ekleme durdurulur. Hizli ekleme penceresinde de calisir (Dawn kimlikleri
     "quickadd-" onekiyle degistirir, form kimligi de birlikte degisir).
  2) [data-ntx-seri-ekle] butonlari (renk-seri-ekle, sepet-capraz-satis):
     tek tikla Karisik Seri ekler, sepet cekmecesini yeniler.
     Cekmece innerHTML ile yenilendigi icin kod burada, olay belgeye baglidir.
*/
(function () {
  if (window.ntxSeri) return;

  function sepetCekmecesi() {
    return document.querySelector('cart-drawer');
  }

  async function sepeteEkle(items) {
    const cekmece = sepetCekmecesi();
    const govde = { items: items };
    if (cekmece && typeof cekmece.getSectionsToRender === 'function') {
      govde.sections = cekmece.getSectionsToRender().map(function (s) { return s.id; });
      govde.sections_url = window.location.pathname;
    }
    const yanit = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(govde),
    });
    const veri = await yanit.json();
    if (!yanit.ok || veri.status) {
      throw new Error(veri.description || veri.message || 'Sepete eklenemedi');
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ntx-seri', cartData: veri });
    }
    if (cekmece && veri.sections) {
      cekmece.classList.remove('is-empty');
      cekmece.renderContents(Object.assign({ id: items[0].id }, veri));
    } else {
      window.location.href = '/cart';
    }
    return veri;
  }

  document.addEventListener('click', async function (e) {
    const buton = e.target.closest('[data-ntx-seri-ekle]');
    if (!buton || buton.disabled) return;
    e.preventDefault();
    const metin = buton.innerHTML;
    buton.disabled = true;
    buton.setAttribute('aria-busy', 'true');
    const oge = { id: Number(buton.dataset.variant), quantity: 1 };
    if (buton.dataset.dagilim) oge.properties = { 'Beden dağılımı': buton.dataset.dagilim };
    try {
      await sepeteEkle([oge]);
      buton.textContent = 'Eklendi ✓';
    } catch (hata) {
      buton.textContent = 'Eklenemedi';
      console.error('[ntx-seri]', hata);
    } finally {
      buton.removeAttribute('aria-busy');
      setTimeout(function () {
        if (!document.body.contains(buton)) return;
        buton.innerHTML = metin;
        buton.disabled = false;
      }, 2200);
    }
  });

  class NtxSeriDagilim extends HTMLElement {
    connectedCallback() {
      if (this.hazir) return;
      this.hazir = true;
      this.hedef = Number(this.dataset.toplam || 5);
      this.girdi = this.querySelector('input[data-ntx-dagilim-girdi]');
      this.satirlar = Array.from(this.querySelectorAll('[data-beden]'));
      this.durum = this.querySelector('[data-ntx-dagilim-durum]');
      this.addEventListener('click', this.tikla.bind(this));
      this.kapsam = this.closest('product-info') || document;
      this.degisti = this.secimiOku.bind(this);
      this.kapsam.addEventListener('change', this.degisti);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.abonelik = subscribe(PUB_SUB_EVENTS.variantChange, this.degisti);
      }
      this.gonder = this.gonderimiDenetle.bind(this);
      document.addEventListener('submit', this.gonder, true);
      this.yaz();
      this.secimiOku();
    }

    disconnectedCallback() {
      if (this.abonelik) this.abonelik();
      if (this.kapsam) this.kapsam.removeEventListener('change', this.degisti);
      document.removeEventListener('submit', this.gonder, true);
      this.hazir = false;
    }

    seriDegeri() {
      const alanlar = this.kapsam.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input');
      for (const alan of alanlar) {
        const etiket = alan.querySelector('legend, label.form__label');
        if (!etiket || etiket.textContent.trim().indexOf(this.dataset.secenek) !== 0) continue;
        const secili = alan.querySelector('input[type="radio"]:checked');
        if (secili) return secili.value;
        const liste = alan.querySelector('select');
        if (liste) return liste.value;
      }
      return this.dataset.ilk || '';
    }

    secimiOku() {
      const onceGizli = this.hidden;
      const karisik = this.seriDegeri() === this.dataset.karisik;
      this.hidden = !karisik;
      this.girdi.disabled = !karisik;
      // Musteri Karisik Seri'yi sectiginde dagilim bolumune gotur (ilk yuklemede degil).
      // Dawn fiyat/stok kutularini yeniden yazdiktan sonra kaydir ki yer kaymasin.
      if (this.ilkOkuma && onceGizli && karisik) {
        clearTimeout(this.kaydirZamani);
        this.kaydirZamani = setTimeout(() => this.scrollIntoView({ behavior: 'smooth', block: 'start' }), 450);
      }
      this.ilkOkuma = true;
    }

    toplam() {
      return this.satirlar.reduce(function (t, s) { return t + Number(s.dataset.adet); }, 0);
    }

    tikla(e) {
      const b = e.target.closest('button[data-yon]');
      if (!b) return;
      const satir = b.closest('[data-beden]');
      let adet = Number(satir.dataset.adet);
      if (b.dataset.yon === '+' && this.toplam() < this.hedef) adet += 1;
      if (b.dataset.yon === '-' && adet > 0) adet -= 1;
      satir.dataset.adet = String(adet);
      this.yaz();
    }

    yaz() {
      const toplam = this.toplam();
      const parcalar = [];
      this.satirlar.forEach(function (s) {
        const adet = Number(s.dataset.adet);
        s.querySelector('[data-sayi]').textContent = adet;
        s.querySelector('button[data-yon="-"]').disabled = adet === 0;
        s.querySelector('button[data-yon="+"]').disabled = toplam >= this.hedef;
        if (adet > 0) parcalar.push(s.dataset.beden + ' ' + adet);
      }, this);
      this.girdi.value = parcalar.join(' · ');
      const eksik = this.hedef - toplam;
      this.classList.toggle('ntx-dagilim--eksik', eksik > 0);
      this.durum.textContent = eksik > 0 ? 'Toplam ' + toplam + '/' + this.hedef + ': ' + eksik + ' adet daha seç.' : 'Toplam ' + this.hedef + '/' + this.hedef + ': seri hazır.';
    }

    gonderimiDenetle(e) {
      // form.id KULLANMA: urun formunda name="id" (varyant) girdisi var, form.id o girdiyi dondurur.
      if (this.hidden || !e.target || !e.target.getAttribute || e.target.getAttribute('id') !== this.dataset.form) return;
      if (this.toplam() === this.hedef) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      this.yaz();
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.durum.focus();
    }
  }

  if (!customElements.get('ntx-seri-dagilim')) customElements.define('ntx-seri-dagilim', NtxSeriDagilim);

  /*
    <ntx-baski-yukle>: "Baskı" secenegi "Baskılı" iken tasarim dosyasi alanini
    gosterir ve dosyayi ZORUNLU tutar; "Baskısız"da alan gizli ve devre disi
    (dosya gonderilmez). Baski ucreti varyant fiyatindadir (numune +300 TL,
    toptan adet basina +100 TL). Baski secenegi olmayan urunde alan isteğe bagli.
  */
  class NtxBaskiYukle extends HTMLElement {
    connectedCallback() {
      if (this.hazir) return;
      this.hazir = true;
      this.girdi = this.querySelector('input[type="file"]');
      this.uyari = this.querySelector('[data-ntx-yukle-uyari]');
      this.zorunlu = this.dataset.zorunlu === 'true';
      this.kapsam = this.closest('product-info') || document;
      this.degisti = this.secimiOku.bind(this);
      this.kapsam.addEventListener('change', this.degisti);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.abonelik = subscribe(PUB_SUB_EVENTS.variantChange, this.degisti);
      }
      this.girdi.addEventListener('change', () => { if (this.girdi.files.length) this.uyari.hidden = true; });
      this.gonder = this.gonderimiDenetle.bind(this);
      document.addEventListener('submit', this.gonder, true);
      this.secimiOku();
    }

    disconnectedCallback() {
      if (this.abonelik) this.abonelik();
      if (this.kapsam) this.kapsam.removeEventListener('change', this.degisti);
      document.removeEventListener('submit', this.gonder, true);
      this.hazir = false;
    }

    secimiOku() {
      if (!this.zorunlu) return;
      const baskili = secenekDegeri(this.kapsam, this.dataset.secenek, this.dataset.ilk) === this.dataset.baskili;
      this.hidden = !baskili;
      this.girdi.disabled = !baskili;
      if (!baskili) this.uyari.hidden = true;
    }

    gonderimiDenetle(e) {
      if (!this.zorunlu || this.hidden || !e.target || !e.target.getAttribute || e.target.getAttribute('id') !== this.dataset.form) return;
      if (this.girdi.files && this.girdi.files.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      this.uyari.hidden = false;
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function secenekDegeri(kapsam, ad, varsayilan) {
    const alanlar = kapsam.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input');
    for (const alan of alanlar) {
      const etiket = alan.querySelector('legend, label.form__label');
      if (!etiket || etiket.textContent.trim().indexOf(ad) !== 0) continue;
      const secili = alan.querySelector('input[type="radio"]:checked');
      if (secili) return secili.value;
      const liste = alan.querySelector('select');
      if (liste) return liste.value;
    }
    return varsayilan || '';
  }

  if (!customElements.get('ntx-baski-yukle')) customElements.define('ntx-baski-yukle', NtxBaskiYukle);

  window.ntxSeri = { sepeteEkle: sepeteEkle };
})();
